export default __webpack_public_path__ + "static/media/profile-3.39d14baf.webp";